import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SandboxService {

  constructor(private router: Router) { }
  get isSandboxActive(): boolean {
    return this.router.url.toLowerCase().includes('sandbox');
  }
}
